import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { refetchUserOnError } from 'utils/refetchUserOnError';

const deleteIssueTemplate = async (templateId: string): Promise<void> => {
  await customAxios.delete(`/issue-templates/${templateId}`);
};

export const useDeleteIssueTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteIssueTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['issue-templates'] }).catch(() => undefined);
    },
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
